// Entry point for 'light' components so that apps do not have to load unneeded
// components from the main index.ts file.
// Be careful editing this, particularly renames/deletes as this can cause
// build failures downstream if something is removed here.

// Components
export { default as ApprovalStatusTag } from './common/ApprovalStatusTag';

// Hooks
export { default as useApprovalConfig } from '../hooks/useApprovalConfig';